// import external dependencies

import "jquery"

// Import everything from autoload
import "./autoload/_bootstrap.js"
import selectLanguage from "./modules/select-language";
import vimeoPlay from "./modules/vimeo-play";
import scrollDown from "./modules/scroll-down";
import accordion from "./modules/accordion";
import selectPlaceholder from "./modules/select-placeholder";
import menuItem from "./modules/menu-item";
import categoryFilter from "./modules/category-filter";
import productPopup from "./modules/product-popup";
import initVideoBackground from './modules/video-background';

document.addEventListener("DOMContentLoaded", () => {
	menuItem();
	selectLanguage();
	vimeoPlay();
	accordion();
	selectPlaceholder();
	categoryFilter();
	productPopup();
	initVideoBackground();
});

window.addEventListener("load", () => {
	setTimeout(() => {
		scrollDown();
	}, 500);
});



// WEBPACK FOOTER //
// ./scripts/main.js